import script from "./AdvertLists.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvertLists.vue?vue&type=script&setup=true&lang=js"

import "./AdvertLists.vue?vue&type=style&index=0&id=5defa3d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5defa3d3"]])

export default __exports__